import { plugins } from '@citation-js/core';
import json from './json';
import { getBibtex } from './text';
import { getBibtxt } from './bibtxt';

var factory = function factory(formatter) {
  return function (data) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var type = opts.type,
        _opts$format = opts.format,
        format = _opts$format === void 0 ? type || 'text' : _opts$format;

    if (format === 'object') {
      return data.map(json);
    } else if (plugins.dict.has(format)) {
      return formatter(data, plugins.dict.get(format), opts);
    } else {
      return '';
    }
  };
};

export default {
  bibtex: factory(getBibtex),
  bibtxt: factory(getBibtxt)
};